<template>
  <div class="promos">
    <Cards promo edit remove :removeData="remove" :items="items" @edit="setItem" @remove="setRemove" />

    <!--    dispatchFn - property passed to pagination component-->
    <!--    to call particular function to fetch data for current page-->
    <Pagination :dispatchFn="'setItems'" :pages="total" :current="page" @setpage="setPage" :perPage="15" />
    <Modal :show="item" @closed="setItem(null)" :width="30" :load="loader">
      <div class="rows">
        <div class="row" v-for="(input, key) in data" :key="key">
          <Ui :data="input" @set="setData({ key: key, value: $event })" />
        </div>
        <div class="buttons">
          <Button label="Сохранить" @click="saveFunction" :disabled="!validData" />
        </div>
      </div>
    </Modal>
    <Modal :show="remove" @closed="setRemove(null)" :width="30" :load="loader">
      <div class="rows">
        <div class="remove" v-if="remove">
          Вы действительно хотите удалить <span>{{remove.code}}</span>?
        </div>
        <div class="buttons">
          <Button label="Удалить" @click="removeFunction" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Cards from '@/components/Cards'
import Ui from '@/components/Ui'
import Pagination from '@/components/Pagination'
import Button from '@/components/ui/Button'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Modal,
    Cards,
    Ui,
    Button,
    Pagination
  },
  computed: {
    ...mapState('promos', [
      'item',
      'items',
      'data',
      'remove',
      'loader',
      'total',
      'page'
    ]),
    ...mapGetters('promos', [
      'validData'
    ])
  },
  methods: {
    ...mapActions('promos', [
      'setItem',
      'setItems',
      'setData',
      'saveFunction',
      'setRemove',
      'removeFunction',
      'setPage'
    ])
  },
  mounted () {
    this.setItems(1)
  }
}
</script>

<style lang="scss" scoped>
.promos{
  @include box(100%, 100%, relative, null, null, null, null, null, null);
  .cards{
    @include size(100%, calc(100% - 3vw));
  }
  .rows{
    @include box(100%, auto, relative, null, null, null, null, null, null);
    @include flex(left, top, row);
    flex-wrap: wrap;
    @include padding(0, 1vw, 0, 0);
    .row{
      @include box(50%, auto, relative, null, null, null, null, null, null);
      &:nth-child(1){
        @include padding(0, 0, 1vw, 0);
      }
      &:nth-child(2){
        @include padding(1vw, 0, 0, 0);
      }
      &:nth-child(3){
        @include padding(0, 1vw, 1vw, 0);
      }
      &:nth-child(4){
        @include padding(1vw, 1vw, 0, 0);
      }
    }
    .remove{
      @include text(0.9vw, 400, 0.05vw, null, left, $modalText);
      span{
        @include text(null, 500, null, null, null, null);
      }
    }
    .buttons{
      @include box(100%, auto, relative, null, null, null, null, null, null);
      @include flex(right, top, row);
      @include padding(0, 2vw, 0, 0);
      .button{
        @include size(10vw, null)
      }
    }
  }
}
</style>
